import { Injectable } from "@angular/core";
import { MockupHttpInterceptor } from "@vattenfall/core";

import { AutocompleteSearch } from "./autocomplete-search.model";

export const data: AutocompleteSearch[] = [
  {
    status: "ok",
    hits: [
      { query: "avtal", type: "statistical" },
      { query: "avtalsvillkor", type: "statistical" },
      { query: "avtalsvillkor elhandel", type: "statistical" },
      { query: "avtalet", type: "statistical" },
      { query: "avtalsvillkor solcell", type: "statistical" },
    ],
  },
];

@Injectable()
export class AutocompleteSearchServiceMockup extends MockupHttpInterceptor<AutocompleteSearch> {
  constructor() {
    super({
      pathMatcher: "/find_v2/_autocomplete",
      delay: 250,
      data,
    });
  }
}
